import React from "react";

const LightningBolt = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M3.33301 11.6667L11.6663 2.5V8.33333H16.6663L8.33301 17.5V11.6667H3.33301Z"
        stroke="#00991F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LightningBolt;
